import {Component, Input, OnInit} from '@angular/core';
import {ServerPaginationService} from "./../../shared/_services/server-pagination.service";
import {ApiRestService} from "./../_services/api-rest.service";
import {ApiRestService as ClientiApiRestService} from "../../Admin/_service/api-rest.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {Lavorazione} from "../Models/lavorazione";
import {ClassicType} from "../../shared/models/ClassicType";
import {FiltriLavorazione} from "../Models/filtri-lavorazione";
import {LavorazioniStoreService} from "../_services/lavorazioni-store.service";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {VociLavorazione} from "../Models/voci-lavorazione";
import {DatePipe} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {DownloadService} from "../../shared/_services/download.service";
import {TranslateService} from "@ngx-translate/core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ImportLavorazioniComponent} from "../ImportLavorazioni/import-lavorazioni.component";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lavorazioni',
  templateUrl: './lavorazioni.component.html'
})
export class LavorazioniComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  collectionSize: number = 0;
  totalQta: number = 0;
  stati: ClassicType[] = [];
  statiSelezionati: ClassicType[] = [{id: "LD", label: "Da Lavorare"}];
  environment = environment;
  @Input() Lavorazioni: Lavorazione[];
  @Input() isModifyEnabled: Boolean = true;
  @Input() hasHeader: Boolean = true;
  @Input() hasFilter: Boolean = true;
  @Input() filtri: FiltriLavorazione = new FiltriLavorazione();
  titolo = "Lavorazioni";
  isMasterSel: boolean = false;
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };
  filterdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'label',
  };
  daLavorare: boolean = false;
  inLavorazione: boolean = false;
  Lavorati: boolean = false;
  Best: any;
  Materiali: string[];
  Colori: string[];
  MaterialiSelezionati: ClassicType[] = [];
  ColoriSelezionati: ClassicType[] = [];
  TipiCliente: ClassicType[];
  ClassicType= ClassicType;
  constructor(
    private paginationService: ServerPaginationService,
    private lavorazioniStore: LavorazioniStoreService,
    private datepipe: DatePipe,
    private apirestservice: ApiRestService,
    private clientiApiRest: ClientiApiRestService,
    private toastService: ToastrService,
    private downloadService: DownloadService,
    private modalService: NgbModal,
    private router: Router,
    public translate: TranslateService,
    ) { }

  ngOnInit(): void {
    this.refreshTable(1);
    this.lavorazioniStore.GetStati();
    this.apirestservice.getListaMateriali().subscribe(data=>{
        this.Materiali = data;
    });
    this.apirestservice.getListacolori().subscribe(data=>{
      this.Colori = data;
    });
    this.clientiApiRest.getTipologieClienti().subscribe(data=>{
      this.TipiCliente = data;
    })
    this.subscriptions.add(this.lavorazioniStore.$stati.subscribe(x => this.stati = x));
    this.subscriptions.add(this.lavorazioniStore.$lista.subscribe(x => {
      if (x) {
        this.collectionSize = x.total;
        this.Lavorazioni = x.data;
        this.totalQta = x.totalQta;
        this.Best = x.best;
      }else{
        this.collectionSize = 0;
        this.Lavorazioni = [];
      }
    }));
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    this.filtri.page = (page - 1) / this.pagesizeserver + 1;
    this.filtri.size = this.pagesizeserver * this.pageSize;
    this.filtri.tipi = this.filtri.tipiClienteSelezionati.map(x=>x.id);
    this.filtri.stato = this.statiSelezionati?.length > 0 ? this.statiSelezionati[0].id : "T";
    this.filtri.materiale = this.MaterialiSelezionati?.map(t=>t.label);
    this.filtri.colore = this.ColoriSelezionati?.map(t=>t.label);
    this.lavorazioniStore.getListaLavorazioni(this.filtri);
    this.isMasterSel = false;
  }
  StateChanged(){
    this.daLavorare = this.statiSelezionati.findIndex(x => x.id == "LD") > -1;
    this.inLavorazione = this.statiSelezionati.findIndex(x => x.id == "LL") > -1;
    this.Lavorati = this.statiSelezionati.findIndex(x => x.id == "LC") > -1;
    this.refreshTable(1);
  }

  lavora(item: VociLavorazione){
    item.dataLavorazione = this.datepipe.transform(new Date(), "yyyy-MM-dd");
  }
  spedisci(item: VociLavorazione){
    item.spedito = true;
  }
  lavorato(item: VociLavorazione){
    item.lavorato = true;
  }
  Annulla(item: VociLavorazione){
    item.lavorato = false;
    item.dataLavorazione = "";
  }
  checkUncheckAll() {
    this.Lavorazioni.forEach(Ordine=>{
      Ordine.voci.forEach(Voce =>{
        Voce.isSelected = this.isMasterSel;
      });
    });
  }
  isAllSelected() {
    this.isMasterSel = true;
    this.Lavorazioni.forEach(Ordine=>{
      Ordine.voci.forEach(Voce =>{
        if (!Voce.isSelected)
          this.isMasterSel = false;
      });
    });
  }
  GetSelectedItems(): VociLavorazione [] {
    var out: VociLavorazione[] = [];
    this.Lavorazioni.forEach(Ordine=>{
      Ordine.voci.forEach(Voce =>{
        if (Voce.isSelected)
          out.push(Voce);
      });
    });
    return out;
  }
  GetAllItems(): VociLavorazione [] {
    var out: VociLavorazione[] = [];
    this.Lavorazioni.forEach(Ordine=>{
      Ordine.voci.forEach(Voce =>{
          out.push(Voce);
      });
    });
    return out;
  }
  LavoraSelezionati(){
    this.GetSelectedItems().forEach(element=> this.lavora(element));
    this.SalvaSelezionati();
  }
  SpedisciSelezionati(){
    this.GetSelectedItems().forEach(element=> this.spedisci(element));
    this.SalvaSelezionati();
  }
  LavoratoSelezionati(){
    this.GetSelectedItems().forEach(element=> this.lavorato(element));
    this.SalvaSelezionati();
  }
  AnnullaSelezionati(){
    if(confirm("Sei sicuro di annullare la lavorazione di questi elementi?")) {
      this.GetSelectedItems().forEach(element => this.Annulla(element));
      this.SalvaSelezionati();
    }
  }
  SalvaSelezionati(){
    this.apirestservice.updateLavorazioni({voci: this.GetSelectedItems()}).subscribe(()=>{
      this.toastService.success("Modifiche apportate","Success!!");
      this.refreshTable(this.newpagegenerated);
    });
  }
  SalvaTutti(){
    this.apirestservice.updateLavorazioni({voci: this.GetAllItems()}).subscribe(()=>{
      this.toastService.success("Modifiche apportate","Success!!");
      this.refreshTable(this.newpagegenerated);
    });
  }
  StampaSelezionati(){
    this.apirestservice.PrintLavorazioni({voci: this.GetSelectedItems()}).subscribe(data => {
      this.downloadService.downloadFile(data)
    });
  }

  orderByNome() {
    if (this.filtri.orderByNome == undefined){
      this.filtri.orderByNome = 'asc';
      this.filtri.orderByData = undefined;
    }
    if (this.filtri.orderByNome == 'asc')
      this.filtri.orderByNome = 'desc';
    if (this.filtri.orderByNome == 'desc')
      this.filtri.orderByNome = 'asc';
    this.refreshTable(1);
  }
  orderByData() {
    if (this.filtri.orderByData == undefined) {
      this.filtri.orderByData = 'asc';
      this.filtri.orderByNome = undefined;
    } else if (this.filtri.orderByData == 'asc')
      this.filtri.orderByData = 'desc';
    else if (this.filtri.orderByData == 'desc')
      this.filtri.orderByData = 'asc';
    this.refreshTable(1);
  }


  ImportDaLavorare(){
    const editmodal = this.modalService.open(ImportLavorazioniComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportLavorazioniComponent>editmodal.componentInstance).IsModal = true;
    (<ImportLavorazioniComponent>editmodal.componentInstance).Uploaded.subscribe(data=>{this.refreshTable(1)});
  }

}
